import {Subscriber} from "../../shared/models/entity/subscriber";
import {Injectable, signal} from "@angular/core";
import {toObservable} from "@angular/core/rxjs-interop";
import {EncryptStorage} from "encrypt-storage";
import {environment} from "../../../environments/environment";
import {User} from "../../shared/models/entity/user";
import { Token } from "../swagger/generated/swagger-client";
import {Partner} from "../../shared/models/entity/partner";

@Injectable({
  providedIn: 'root'
})
export class DataRegistry {
  readonly activeSubscriber = signal<Subscriber | null>(null);
  readonly activeSubscriber$ = toObservable(this.activeSubscriber);

  readonly activeUser = signal<User | null>(null);
  readonly activeUser$ = toObservable(this.activeUser);

  readonly activePartner = signal<Partner | null>(null);
  readonly activePartner$ = toObservable(this.activePartner);

  readonly activeClientToken = signal<Token | null>(null);
  readonly activeClientToken$ = toObservable(this.activeClientToken);

  readonly activePartnerToken = signal<Token | null>(null);
  readonly activePartnerToken$ = toObservable(this.activePartnerToken);

  public readonly clientCredentialStorage = new EncryptStorage(environment.encryption.auth.client, {prefix: '@cth', storageType: "localStorage"});
  public readonly partnerCredentialStorage = new EncryptStorage(environment.encryption.auth.partner, {prefix: '@pth', storageType: "localStorage"});
}
